import * as React from "react";
import { CustomButton, ButtonType, Modal, ModalBody, ModalFooter, ModalSize, CustomDatePicker, CustomSubmitButton, Form, HiddenInput, AlertMessage, AlertType, Table } from "soprasteria-ui-library";
import { useRouteMatch, useHistory } from "react-router";
import { RISK_POT_REPORT } from "../../../../utils/RouteConstants";
import { RiskPotReportApi } from "../../../../api/RiskPotReportApi";
import { useAuth } from "../../../../App";
import { ICreateRiskPotReport, IRiskPotReport } from "../../../../models/IRiskPotReport";
import { setMessage } from "../../../../helpers/MessageHelper";
import { Link } from "react-router-dom";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";

interface IRiskPotReportTab {
    canCreateRiskPotReport: boolean;
    minimumStartDate: Date;
    patientId: number;
    riskPotReports: IRiskPotReport[];
    reloadData: () => void;
}

interface ILoading {
    isLoading: boolean;
    riskPotReportId: number;
}

export const RiskPotReportTab: React.FunctionComponent<IRiskPotReportTab> = ({ canCreateRiskPotReport, patientId, riskPotReports, minimumStartDate, reloadData }) => {
    const auth = useAuth();
    const api = new RiskPotReportApi(auth);
    const history = useHistory();
    let match = useRouteMatch();
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<ILoading>();


    const onSubmit = (data: ICreateRiskPotReport) => {
        setIsSubmitting(true);
        api.createRiskPotReport(data, (riskPotReportId: number) => {
            document.getElementById("close-create-risk-pot-report-modal")?.click();
            history.push(`${match.url}/${RISK_POT_REPORT}/${riskPotReportId}`);
        }, (error: string) => {
            const message = setMessage(error, errorMessage ?? "");
            setErrorMessage(message);
        }, () => setIsSubmitting(false));
    }

    const renderTableLink = (linkText: string, riskPotReportId: number) => {
        return <td className="table-data-link"><Link to={`${match.url}/${RISK_POT_REPORT}/${riskPotReportId}`}>{linkText}</Link></td>
    }

    const removeRiskPotReport = (riskPotReportId: number) => {
        const confirmed = window.confirm("Är du säker på att du vill ta bort riskpottsärendet?");
        if (confirmed) {
            setIsLoading({ isLoading: true, riskPotReportId: riskPotReportId });
            api.deleteRiskPotReport(riskPotReportId, reloadData, undefined, () => setIsLoading({ isLoading: false, riskPotReportId: riskPotReportId }));
        }
    }

    return (
        <section>
            {
                canCreateRiskPotReport ?
                    <div className="panel text-right">
                        <CustomButton buttonText="Skapa riskpottsärende" buttonType={ButtonType.create} data-toggle="modal" data-target="#create-risk-pot-report-modal" onClick={() => setRenderModal(true)} />
                    </div>
                    : null
            }
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Riskpottsnummer</th>
                        <th>Startdatum</th>
                        <th>Slutdatum</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        riskPotReports?.length > 0 ?
                            riskPotReports.map((riskPotReport, key) =>
                                <tr key={key} className="clickable-row">
                                    {renderTableLink(riskPotReport.riskPotReportNumber, riskPotReport.riskPotReportId)}
                                    {renderTableLink(dateTimeToDateString(riskPotReport.assessmentStartDate), riskPotReport.riskPotReportId)}
                                    {renderTableLink(dateTimeToDateString(riskPotReport.assessmentEndDate), riskPotReport.riskPotReportId)}
                                    <td className="delete-btn">
                                        {
                                            riskPotReport.canBeDeleted ?
                                                <CustomButton
                                                    buttonType={ButtonType.delete}
                                                    buttonText=""
                                                    onClick={() => removeRiskPotReport(riskPotReport.riskPotReportId ?? 0)}
                                                    isLoading={isLoading?.riskPotReportId === riskPotReport.riskPotReportId && isLoading?.isLoading} />
                                                : null
                                        }
                                    </td>
                                </tr>
                            )
                            : <tr><td colSpan={4}>Det finns inga riskpottsärenden</td></tr>
                    }
                </tbody>
            </Table>
            <Modal header="Skapa riskpottsärende" id="create-risk-pot-report-modal" modalSize={ModalSize.normal}>
                {
                    renderModal ?
                        <Form onSubmit={onSubmit}>
                            <ModalBody>
                                <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                                <HiddenInput name="patientId" value={patientId.toString()} />
                                <CustomDatePicker name="riskPotReportStartDate" label="Startdatum" max={new Date()} min={new Date(minimumStartDate)} required />
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} id="close-create-risk-pot-report-modal" buttonText="Avbryt" data-dismiss="modal" onClick={() => setRenderModal(false)} />
                                <CustomSubmitButton isLoading={isSubmitting}>Skapa</CustomSubmitButton>
                            </ModalFooter>
                        </Form>
                        : null
                }
            </Modal>
        </section>
    )
}